/* eslint-disable jsx-a11y/anchor-is-valid */
import BoardSwitcherImg from 'assets/img/icons/board-switcher.svg';
import Dashboard from 'assets/img/icons/dashboard.svg';
import Bispro from 'assets/img/icons/suitcase.svg';
import Organization from 'assets/img/icons/Organization.svg';
import Matrix from 'assets/img/icons/dotmatrix.svg';
import Jobdesc from 'assets/img/icons/worker.svg';
import Workload from 'assets/img/icons/workloadAnalys.svg';
import FindBoard from 'components/layouts/sidebar/findBoard';
import { FeatureFlags } from 'context/featureFlag';
import {
  type CSSProperties, memo, useContext, useEffect, useState,
} from 'react';
import {
  Briefcase, Circle, Clipboard, Home,
} from 'react-feather';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';
import { Hooks } from 'providers';
import PopUpSideBar from './popUpSideBar';
import DataHooks from './dataHooks';

type ExpandedMenu =
  | 'boardSwitcher'
  | 'showBusinessProcess'
  | 'showOrganizations'
  | 'showMatrix'
  | 'showWla'
  | 'bp'
  | 'rp'
  | 'showOkrReporting'
  | 'showOkrAdministrative'
  | 'home'
  | 'reporting'
  | 'okr'
  | 'initiatives'
  | 'actionplan'
  | 'team'
  | 'department';

type ListDataProps = {
  backOffice?: boolean;
  bo?: boolean;
  loginType?: string;
  showDatabank?: boolean;
};

type HooksContextValue = {
  sideBar: boolean;
};

type FeatureFlagContextValue = {
  businessProcess?: boolean;
};

const routeMenuByPath: Record<string, ExpandedMenu> = {
  '/structure-view': 'showOrganizations',
  '/employees': 'showOrganizations',
  '/wla/dashboard-division': 'showWla',
  '/wla/list': 'showWla',
};

const boardSwitcherStyle: CSSProperties = {
  width: '100%',
  height: '44px',
  display: 'flex',
  flexWrap: 'nowrap',
  justifyContent: 'left',
  alignItems: 'center',
  opacity: 1,
  color: '#ffffff',
  background: 'linear-gradient(16deg, rgba(27, 94, 153, 1) 4%, rgba(46, 156, 255, 1) 60%)',
  border: 0,
  borderRadius: '10px',
  padding: '12px 13px',
  textAlign: 'center',
  cursor: 'pointer',
  gap: '25px',
  outline: 'none',
};

const boardNameStyle: CSSProperties = {
  width: '68%',
  fontFamily: 'Quicksand',
  fontSize: '12px',
  fontWeight: 700,
  lineHeight: '15px',
  textAlign: 'center',
  color: '#ffffff',
};

function ListData(props: Readonly<ListDataProps>) {
  const { loginType, showDatabank } = props;
  const { t } = useTranslation();
  const location = useLocation();
  const { sideBar } = useContext(Hooks) as HooksContextValue;
  const { listSubSideBar } = DataHooks();
  const [isShowFindBoard, setIsShowFindBoard] = useState(false);
  const [expandedMenu, setExpandedMenu] = useState<ExpandedMenu | null>(null);
  const routeMenu = routeMenuByPath[location.pathname];
  const activated = (link: ExpandedMenu) => {
    setExpandedMenu((currentMenu) => (currentMenu === link ? null : link));
  };

  const isActive = (link: ExpandedMenu) => link === expandedMenu || link === routeMenu;
  const style = {
    kpiIcon: {
      fill: '#C4C4C4',
      height: '14px',
      width: '14px',
      borderRadius: '50%',
      color: 'rgb(196, 196, 196)',
    },
  };
  const featureFlagListed = useContext(FeatureFlags) as FeatureFlagContextValue;
  useEffect(() => {
    if (!sideBar) {
      setExpandedMenu(null);
    }
    setIsShowFindBoard(false);
  }, [sideBar]);

  const renderListSidebar = () => {
    switch (loginType) {
      case 'user':
        return (
          <>
            <li
              id="sidebar-board"
              className=" position-relative "
              style={{
                margin: '0 12px',
              }}
            >
              <div className="position-relative">
                <button
                  type="button"
                  data-toggle="collapse"
                  onClick={() => {
                    activated('boardSwitcher');
                    setIsShowFindBoard(!isShowFindBoard);
                  }}
                  className={`board-switcher ${
                    !isActive('boardSwitcher') && 'collapsed'
                  } ${sideBar ? '' : 'hide'}`}
                  style={boardSwitcherStyle}
                >
                  <img src={BoardSwitcherImg} alt="board-switcher" />
                  <span
                    className="board-switcher text-truncate"
                    style={boardNameStyle}
                  >
                    {localStorage.getItem('board_name')}
                  </span>
                </button>
                <FindBoard
                  isShow={isShowFindBoard}
                  setIsShow={setIsShowFindBoard}
                />
              </div>
            </li>
            <li id="sidebar-dashboard" className="sidebar-item">
              <Link
                to={{
                  pathname: '/dashboard',
                  state: { sideBarHide: !sideBar },
                }}
                className="font-weight-bold sidebar-link"
              >
                <div className="iconSideBar">
                  <img src={Dashboard} alt="dashboard.svg" />
                </div>
                <span className="align-middle">{t('side_bar.dashboard')}</span>
              </Link>
            </li>
            <hr className="" />
            {featureFlagListed.businessProcess && (
              <li id="sidebar-process" className="sidebar-item">
                <Link
                  to={{
                    pathname: '/business-process',
                    state: { sideBarHide: !sideBar },
                  }}
                  onClick={
                    sideBar
                      ? () => activated('showBusinessProcess')
                      : undefined
                  }
                  className="font-weight-bold sidebar-link collapsed"
                >
                  <div className="iconSideBar">
                    <img src={Bispro} alt="bispro.svg" />
                  </div>
                  <span className="align-middle">
                    {t('side_bar.business_process')}
                  </span>
                </Link>
              </li>
            )}
            <li id="sidebar-organization" className="sidebar-item">
              <PopUpSideBar
                data={listSubSideBar('organization')}
                className="popUpSidebar"
                style={{ bottom: '-37%' }}
              >
                <Link
                  to={`${
                    location.pathname + location.search
                  }#showOrganizations`}
                  onClick={
                    sideBar
                      ? () => activated('showOrganizations')
                      : undefined
                  }
                  data-toggle="collapse"
                  className={`font-weight-bold sidebar-link ${
                    !isActive('showOrganizations') && 'collapsed'
                  }`}
                >
                  <div className="iconSideBar">
                    <img src={Organization} alt="organization.svg" />
                  </div>
                  <span className="align-middle">
                    {t('side_bar.organization')}
                  </span>
                </Link>
              </PopUpSideBar>
              <ul
                id="org"
                className={`sidebar-dropdown list-unstyled collapseSideBar ${
                  isActive('showOrganizations') && 'show'
                }`}
              >
                <div className="overflow-hidden">
                  <li id="organization-structure" className="sidebar-item">
                    <Link className="sidebar-link" to="/structure-view">
                      {t('side_bar.structure_view')}
                    </Link>
                  </li>
                  <li
                    id="organization-job-list"
                    className="sidebar-item d-none"
                  >
                    <Link className="sidebar-link" to="/organizations">
                      {t('side_bar.index_view')}
                    </Link>
                  </li>
                  <li id="organization-employee" className="sidebar-item">
                    <Link className="sidebar-link" to="/employees">
                      {t('side_bar.employees')}
                    </Link>
                  </li>
                  {/* <li className="sidebar-item">
                    <Link className="sidebar-link" to="#">
                      Grade Mapping
                    </Link>
                  </li> */}
                  {/* <li className="sidebar-item">
                    <Link className="sidebar-link" to="/job-level">
                      Job Level
                    </Link>
                  </li> */}
                </div>
              </ul>
            </li>
            <li id="sidebar-matrix" className="sidebar-item">
              <PopUpSideBar
                data={listSubSideBar('matrix')}
                className="popUpSidebar"
                style={{ bottom: '-38%' }}
              >
                <Link
                  to={{
                    pathname: '/matrix',
                    state: { sideBarHide: !sideBar },
                  }}
                  onClick={
                    sideBar ? () => activated('showMatrix') : undefined
                  }
                  className="font-weight-bold sidebar-link collapsed"
                >
                  <div className="iconSideBar">
                    <img src={Matrix} alt="matrix.svg" />
                  </div>
                  <span className="align-middle">{t('side_bar.matrix')}</span>
                </Link>
              </PopUpSideBar>
            </li>
            <li id="sidebar-job-desc" className="sidebar-item">
              <Link
                to={{
                  pathname: '/job-desc',
                  state: { sideBarHide: !sideBar },
                }}
                className="font-weight-bold sidebar-link collapsed"
              >
                <div className="iconSideBar">
                  <img src={Jobdesc} alt="jobdesc.svg" />
                </div>
                <span className="align-middle">{t('side_bar.job_desc')}</span>
              </Link>
            </li>
            <li id="sidebar-wla" className="sidebar-item">
              <PopUpSideBar
                data={listSubSideBar('workloadAnalys')}
                className="popUpSidebar"
                style={{ bottom: '-36' }}
              >
                <Link
                  to={`${location.pathname + location.search}#showWla`}
                  onClick={
                    sideBar ? () => activated('showWla') : undefined
                  }
                  data-toggle="collapse"
                  className={`font-weight-bold sidebar-link ${
                    !isActive('showWla') && 'collapsed'
                  }`}
                >
                  <div className="iconSideBar">
                    <img src={Workload} alt="workload.svg" />
                  </div>
                  <span className="align-middle">{t('side_bar.wla')}</span>
                </Link>
              </PopUpSideBar>
              <ul
                id="mtrx"
                className={`sidebar-dropdown list-unstyled collapseSideBar ${
                  isActive('showWla') && 'show'
                }`}
              >
                <div className="overflow-hidden">
                  <li id="wla-analytics" className="sidebar-item">
                    <Link
                      to={{
                        pathname: '/wla/dashboard-division',
                        search: '?tab=1',
                        state: { sideBarHide: !sideBar },
                      }}
                      className="sidebar-link"
                    >
                      {t('side_bar.wla_analytics')}
                    </Link>
                  </li>
                  <li id="wla-monitoring" className="sidebar-item">
                    <Link
                      className="sidebar-link"
                      to={{
                        pathname: '/wla/list',
                        state: { sideBarHide: !sideBar },
                      }}
                    >
                      {t('side_bar.wla_list')}
                    </Link>
                  </li>
                </div>
              </ul>
            </li>
          </>
        );
        break;
      case 'admin':
        return (
          <>
            <li className="sidebar-header">
              {' '}
              {t('side_bar.main')}
            </li>
            <li className="sidebar-item active">
              <Link
                to="/back-office/dashboard"
                className="font-weight-bold sidebar-link"
              >
                <i className="align-middle" data-feather="box" />
                {' '}
                <span className="align-middle">{t('side_bar.dashboard')}</span>
              </Link>
            </li>
            <li className="sidebar-item active">
              <Link
                to="/back-office/company"
                className="font-weight-bold sidebar-link"
              >
                <i className="align-middle" data-feather="box" />
                {' '}
                <span className="align-middle">{t('side_bar.company')}</span>
              </Link>
            </li>
            <li className="sidebar-item active">
              <Link
                to="/back-office/user-management"
                className="font-weight-bold sidebar-link"
              >
                <i className="align-middle" data-feather="box" />
                {' '}
                <span className="align-middle">
                  {t('side_bar.user_management')}
                </span>
              </Link>
            </li>
            {/* databank */}
            <li className="sidebar-item pointerOff">
              <a
                // onClick={() => props?.setShowDatabank(!showDatabank)}
                data-toggle="collapse"
                className={`font-weight-bold sidebar-link ${
                  !showDatabank && 'collapsed'
                }`}
              >
                <i className="align-middle" data-feather="server" />
                {' '}
                <span className="align-middle">
                  {t('side_bar.org_dataBank')}
                </span>
              </a>
              <ul
                id="org"
                className={`sidebar-dropdown list-unstyled collapse ${
                  showDatabank && 'show'
                }`}
              >
                <li className="sidebar-item">
                  <Link
                    className="sidebar-link"
                    to="/databank/competency?type=core_competency"
                  >
                    {t('side_bar.core_comp')}
                  </Link>
                </li>
                <li className="sidebar-item">
                  <Link
                    className="sidebar-link"
                    to="/databank/competency?type=functional_competency"
                  >
                    {t('side_bar.func_comp')}
                  </Link>
                </li>
                <li className="sidebar-item">
                  <Link
                    className="sidebar-link"
                    to="/databank/competency?type=leadrship_competency"
                  >
                    {t('side_bar.lead_comp')}
                  </Link>
                </li>
              </ul>
            </li>
            <li className="sidebar-item active">
              <Link
                to="/back-office/subscription"
                className="font-weight-bold sidebar-link"
              >
                <i className="align-middle" data-feather="box" />
                {' '}
                <span className="align-middle">
                  {t('side_bar.subscription')}
                </span>
              </Link>
            </li>
            <li className="sidebar-item active">
              <Link
                to="/back-office/apqc"
                className="font-weight-bold sidebar-link"
              >
                <i className="align-middle" data-feather="box" />
                {' '}
                <span className="align-middle">APQC</span>
              </Link>
            </li>
            <li className="sidebar-item active">
              <Link
                to="/workload/list"
                className="font-weight-bold sidebar-link"
              >
                <i className="align-middle" data-feather="box" />
                {' '}
                <span className="align-middle">{t('side_bar.workload')}</span>
              </Link>
            </li>
          </>
        );
        break;
      case 'kpi':
        return (
          <ul className="sidebar-nav">
            <li className="sidebar-header">Main</li>
            <li className="sidebar-item active">
              <a
                href="rize_KPIDashboard.html"
                className="font-weight-bold sidebar-link"
              >
                <Home size={18} />
                <span className="align-middle">Dashboard</span>
              </a>
            </li>
            <li className="sidebar-item">
              <Link
                to="#bp"
                data-toggle="collapse"
                className={`font-weight-bold sidebar-link ${
                  isActive('bp') && 'collapsed'
                }`}
                onClick={() => {
                  activated('bp');
                }}
              >
                <Briefcase size={18} />
                <span className="align-middle">Activity</span>
              </Link>
              <ul
                id="bp"
                className={`sidebar-dropdown list-unstyled collapse ${
                  isActive('bp') && 'show'
                }`}
              >
                <li className="sidebar-item">
                  <Link className="sidebar-link" to="/kpi-list">
                    My KPI
                  </Link>
                </li>
                <li className="sidebar-item">
                  <Link className="sidebar-link" to="/activity">
                    My Activity
                  </Link>
                </li>
              </ul>
            </li>
            <li className="sidebar-item">
              <Link
                to="#rp"
                data-toggle="collapse"
                className={`font-weight-bold sidebar-link ${
                  isActive('rp') && 'collapsed'
                }`}
                onClick={() => {
                  activated('rp');
                }}
              >
                <Clipboard size={18} />
                <span className="align-middle">Report</span>
              </Link>
              <ul
                id="rp"
                className={`sidebar-dropdown list-unstyled collapse ${
                  isActive('rp') && 'show'
                }`}
              >
                <li className="sidebar-item">
                  <a className="sidebar-link" href="rize_KPIReportOverall.html">
                    Overall Report
                  </a>
                </li>
                <li className="sidebar-item">
                  <a className="sidebar-link" href="rize_KPIReportMonthly.html">
                    Monthly Report
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        );
        break;

      case 'kpi-admin':
        return (
          <>
            <li className="sidebar-header">Main</li>
            <li className="sidebar-item ">
              <Link
                to="/v2/kpi/dashboard"
                className="font-weight-bold sidebar-link"
              >
                <Circle style={style.kpiIcon} size={18} />
                <span className="align-middle">Home</span>
              </Link>
            </li>
            <li className="sidebar-item ">
              <Link
                to="#showOkrReporting"
                onClick={() => activated('showOkrReporting')}
                data-toggle="collapse"
                className={`font-weight-bold sidebar-link ${
                  !isActive('showOkrReporting') && 'collapsed'
                }`}
              >
                <Circle style={style.kpiIcon} size={18} />
                <span className="align-middle">Reporting</span>
              </Link>
              <ul
                id="business_process"
                className={`sidebar-dropdown list-unstyled collapse ${
                  isActive('showOkrReporting') && 'show'
                }`}
              >
                <li className="sidebar-item ">
                  <Link
                    to="/v2/kpi/overview-performance"
                    className="font-weight-bold sidebar-link"
                  >
                    <Circle style={style.kpiIcon} size={18} />
                    <span className="align-middle">Overview</span>
                  </Link>
                </li>
                <li className="sidebar-item ">
                  <Link
                    to="/v2/kpi/okr-performance"
                    className="font-weight-bold sidebar-link"
                  >
                    <Circle style={style.kpiIcon} size={18} />
                    <span className="align-middle">OKR</span>
                  </Link>
                </li>
                <li className="sidebar-item ">
                  <Link
                    to="/v2/kpi/department-performance"
                    className="font-weight-bold sidebar-link"
                  >
                    <Circle style={style.kpiIcon} size={18} />
                    <span className="align-middle">Departement & Team</span>
                  </Link>
                </li>
                <li className="sidebar-item ">
                  <Link
                    to="/v2/kpi/employee-performance"
                    className="font-weight-bold sidebar-link"
                  >
                    <Circle style={style.kpiIcon} size={18} />
                    <span className="align-middle">Employee</span>
                  </Link>
                </li>
              </ul>
            </li>
            <li className="sidebar-item ">
              <Link
                to="#showOkrAdministrative"
                onClick={() => activated('showOkrAdministrative')}
                data-toggle="collapse"
                className={`font-weight-bold sidebar-link ${
                  !isActive('showOkrAdministrative') && 'collapsed'
                }`}
              >
                <Circle style={style.kpiIcon} size={18} />
                <span className="align-middle">Administrative</span>
              </Link>
              <ul
                id="business_process"
                className={`sidebar-dropdown list-unstyled collapse ${
                  isActive('showOkrAdministrative') && 'show'
                }`}
              >
                <li className="sidebar-item ">
                  <Link
                    to="/v2/kpi/manage-employee"
                    className="font-weight-bold sidebar-link"
                  >
                    <Circle style={style.kpiIcon} size={18} />
                    <span className="align-middle">Employee</span>
                  </Link>
                </li>
                <li className="sidebar-item ">
                  <Link
                    to="/v2/kpi/manage-team"
                    className="font-weight-bold sidebar-link"
                  >
                    <Circle style={style.kpiIcon} size={18} />
                    <span className="align-middle">Team</span>
                  </Link>
                </li>
                <li className="sidebar-item ">
                  <Link
                    to="/v2/kpi/manage-department"
                    className="font-weight-bold sidebar-link"
                  >
                    <Circle style={style.kpiIcon} size={18} />
                    <span className="align-middle">Departement</span>
                  </Link>
                </li>
              </ul>
            </li>

            <li className="sidebar-header">Performance</li>
            <li className="sidebar-item ">
              <Link to="/v2/kpi/okr" className="font-weight-bold sidebar-link">
                <Circle style={style.kpiIcon} size={18} />
                <span className="align-middle">OKR</span>
              </Link>
            </li>
            <li className="sidebar-item ">
              <Link
                to="/v2/kpi/initiative"
                className="font-weight-bold sidebar-link"
              >
                <Circle style={style.kpiIcon} size={18} />
                <span className="align-middle">Initiatives</span>
              </Link>
            </li>
            <li className="sidebar-item ">
              <Link
                to="/v2/kpi/action-plan"
                className="font-weight-bold sidebar-link"
              >
                <Circle style={style.kpiIcon} size={18} />
                <span className="align-middle">Action Plan</span>
              </Link>
            </li>
          </>
        );
        break;

      case 'pt-employee':
        return (
          <>
            <li className="sidebar-header">MAIN</li>
            <li className="sidebar-item">
              <Link
                to="/v2/kpi/dashboard-employee"
                onClick={() => activated('home')}
                data-toggle="collapse"
                className={`font-weight-bold sidebar-link ${
                  !isActive('home') && 'collapsed'
                }`}
              >
                <i className="align-middle" data-feather="briefcase" />
                {' '}
                <div className="d-flex align-items-center gap16px">
                  <Circle style={style.kpiIcon} size={18} />
                  <span className="align-middle">Home</span>
                </div>
              </Link>
            </li>
            <li className="sidebar-item">
              <Link
                to="/v2/kpi/report"
                onClick={() => activated('reporting')}
                data-toggle="collapse"
                className={`font-weight-bold sidebar-link ${
                  !isActive('reporting') && 'collapsed'
                }`}
              >
                <i className="align-middle" data-feather="briefcase" />
                {' '}
                <div className="d-flex align-items-center gap16px">
                  <Circle style={style.kpiIcon} size={18} />
                  <span className="align-middle">Reporting</span>
                </div>
              </Link>
            </li>
            <li className="sidebar-header">PERFORMANCE</li>
            <li className="sidebar-item">
              <Link
                to="/v2/kpi/okr-employee"
                onClick={() => activated('okr')}
                data-toggle="collapse"
                className={`font-weight-bold sidebar-link ${
                  !isActive('okr') && 'collapsed'
                }`}
              >
                <i className="align-middle" data-feather="briefcase" />
                {' '}
                <div className="d-flex align-items-center gap16px">
                  <Circle style={style.kpiIcon} size={18} />
                  <span className="align-middle">OKR</span>
                </div>
              </Link>
            </li>
            <li className="sidebar-item">
              <Link
                to="/v2/kpi/initiative-employee"
                onClick={() => activated('initiatives')}
                data-toggle="collapse"
                className={`font-weight-bold sidebar-link ${
                  !isActive('initiatives') && 'collapsed'
                }`}
              >
                <i className="align-middle" data-feather="briefcase" />
                {' '}
                <div className="d-flex align-items-center gap16px">
                  <Circle style={style.kpiIcon} size={18} />
                  <span className="align-middle">Initiatives</span>
                </div>
              </Link>
            </li>
            <li className="sidebar-item">
              <Link
                to="/v2/kpi/action-plan-employee"
                onClick={() => activated('actionplan')}
                data-toggle="collapse"
                className={`font-weight-bold sidebar-link ${
                  !isActive('actionplan') && 'collapsed'
                }`}
              >
                <i className="align-middle" data-feather="briefcase" />
                {' '}
                <div className="d-flex align-items-center gap16px">
                  <Circle style={style.kpiIcon} size={18} />
                  <span className="align-middle">Action Plan</span>
                </div>
              </Link>
            </li>
            <li className="sidebar-item d-none">
              <Link
                to="/v2/kpi/team-employee"
                onClick={() => activated('team')}
                data-toggle="collapse"
                className={`font-weight-bold sidebar-link ${
                  !isActive('team') && 'collapsed'
                }`}
              >
                <i className="align-middle" data-feather="briefcase" />
                {' '}
                <div className="d-flex align-items-center gap16px">
                  <Circle style={style.kpiIcon} size={18} />
                  <span className="align-middle">Team</span>
                </div>
              </Link>
            </li>
            <li className="sidebar-item d-none">
              <Link
                to="/v2/kpi/department-employee"
                onClick={() => activated('department')}
                data-toggle="collapse"
                className={`font-weight-bold sidebar-link ${
                  !isActive('department') && 'collapsed'
                }`}
              >
                <i className="align-middle" data-feather="briefcase" />
                {' '}
                <div className="d-flex align-items-center gap16px">
                  <Circle style={style.kpiIcon} size={18} />
                  <span className="align-middle">Department</span>
                </div>
              </Link>
            </li>
          </>
        );
        break;

      default:
        return null;
    }
  };
  return <ul className="sidebar-nav">{renderListSidebar()}</ul>;
}
export default memo(ListData);
